import {useSelector, useDispatch} from 'react-redux'
import {setUser, initialState} from 'store/auth/userSlice'
import {apiOAuth, apiSignIn, apiSignOut, apiSignUp, apiVerifyDevice} from 'services/AuthService'
import {onSignInSuccess, onSignOutSuccess} from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import {REDIRECT_URL_KEY} from 'constants/app.constant'
import {useNavigate} from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const {token, signedIn} = useSelector((state) => state.auth.session)

    const oAuth = async (values) => {
        try {
            const resp = await apiOAuth(values)
            if (resp.data) {
                const {token} = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(setUser(resp.data.user || {
                        userName: 'Anonymous',
                        authority: ['USER'],
                        email: ''
                    }))
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)

                return {
                    status: 'success',
                    message: ''
                }
            }
            return {
                status: 'failed',
                message: resp.data.message
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data || errors.toString()
            }
        }
    }

    // Token + user-г Redux-д суулгаж, зохих хуудас руу шилжүүлнэ. signIn болон
    // verifyDevice хоёулаа амжилттай хариу ирэхэд үүнийг дуудна.
    const finishSignIn = (resp) => {
        const {token} = resp.data
        const is_expired = resp.data.user?.is_expired
        dispatch(onSignInSuccess(token))
        if (resp.data.user) {
            dispatch(setUser(resp.data.user || {
                avatar: '', userName: 'Anonymous', authority: ['USER'], email: ''
            }))
        }
        if (is_expired === 1) {
            navigate('/wallet/password?is_expired=1', {replace: true})
            return {status: 'failed', message: 'is_expired'}
        }
        const redirectUrl = query.get(REDIRECT_URL_KEY)
        navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
        return {status: 'success', message: ''}
    }

    // Танихгүй төхөөрөмжөөс ирсэн имэйл OTP-г баталгаажуулж нэвтрэлтийг дуусгана.
    const verifyDevice = async (values) => {
        try {
            const resp = await apiVerifyDevice(values)
            if (resp.data.status === -1) {
                return {status: 'failed', message: resp.data.message}
            }
            return finishSignIn(resp)
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors?.response?.data || errors.toString()
            }
        }
    }

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            //console.log(resp)
            // Танихгүй төхөөрөмж → token олгогдоогүй, OTP баталгаажуулалт шаардана.
            if (resp.data.device_verification) {
                return {
                    status: 'device_verification',
                    message: resp.data.message,
                    email: resp.data.email,
                }
            }
            if (resp.data.status !== -1) {
                const {token} = resp.data
                const is_expired = resp.data.user.is_expired
            dispatch(onSignInSuccess(token))
            if (resp.data.user) {
                dispatch(setUser(resp.data.user || {
                    avatar: '',
                    userName: 'Anonymous',
                    authority: ['USER'],
                    email: ''
                }))
            }
                if (is_expired === 1) {
                navigate('/wallet/password?is_expired=1', { replace: true }) 
                return {
                        status: 'failed',
                        message: 'is_expired'
                    }
                }

                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(setUser(resp.data.user || {
                        avatar: '',
                        userName: 'Anonymous',
                        authority: ['USER'],
                        email: ''
                    }))
                }

                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)

                return {
                    status: 'success',
                    message: '',
                }

            }
            else{
                return {
                    status: 'failed',
                    message: resp.data.message,
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data || errors.toString()
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
           // console.log(resp)
            if (resp.data) {
                const {status, message, id, signup_token} = resp.data
                if (status === -1) {
                    return {
                        status: 'failed',
                        message: message
                    }
                } else {
                    /*dispatch(onSignInSuccess(token))
                    if(resp.data.user) {
                        dispatch(setUser(resp.data.user || {
                            avatar: '',
                            userName: 'Anonymous',
                            authority: ['USER'],
                            email: ''
                        }))
                    }*/
                    //const redirectUrl = query.get(REDIRECT_URL_KEY)
                    //navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                    return {
                        status: 'success',
                        message: message,
                        cu_main_id: id,
                        // cancel-signup / master/pdf/sign(-image)-д cu_main_id-тай хамт илгээнэ
                        signup_token
                    }
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
        }
    }

    const signUpDan = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const {status, message} = resp.data
                if (status === -1) {
                    return {
                        status: 'failed',
                        message: message
                    }
                } else {
                    const redirectUrl = query.get(REDIRECT_URL_KEY)
                    navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                    return {
                        status: 'success',
                        message: message
                    }
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        await apiSignOut()
        handleSignOut()
    }

    const resetPass = async (values) => {
        try {
            const resp = await apiSignIn(values)
            if (resp.data) {
                const {token} = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(setUser(resp.data.user || {
                        avatar: '',
                        userName: 'Anonymous',
                        authority: ['USER'],
                        email: ''
                    }))
                }
                return {
                    status: 'success',
                    message: 'Нууц үг амжилттай шинэчлэгдлээ',
                }

            }
        } catch (errors) {
            return {
                status: 'failed',
                // message: errors?.response?.data || errors.toString()
                message: 'Нэвтрэх мэдээлэл буруу байна.'
            }
        }
    }

    return {
        authenticated: token && signedIn,
        oAuth,
        signIn,
        verifyDevice,
        signUp,
        signUpDan,
        signOut,
        resetPass
    }
}

export default useAuth